<div class="container">
    <div class="row pt-3" *ngIf="objectiveService.showLandingHeader">
        <div class="col-12">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active':objectiveService.showLandingMetricTab == true}" (click)="updateTabSelected('metric')"
                       cvLocalizedText langSection="Objectives" langKey="Metric_View">Metric View</a>
                </li>

                <li class="nav-item">
                    <a class="nav-link" [ngClass]="{'active':objectiveService.showLandingGroupsTab == true}" (click)="updateTabSelected('groups')"
                       cvLocalizedText langSection="Objectives" langKey="Group_View">Group View</a>
                </li>
            </ul>
        </div>
    </div>

    <div class="row align-items-center py-3" *ngIf="objectiveService.showLandingHeader">
        <div class="col-3">
            <button type="button" class="btn btn-primary btn-icon" (click)="clickNew()">
                <svg><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
                <span cvLocalizedText langSection="Objectives" langKey="New_Objective">New Objective</span>
            </button>
        </div>

        <div class="col-6"></div>

        <div class="col-3">
            <div class="search-box live-search">
                <input type="search" class="form-control form-control-gray" placeholder="Search" [(ngModel)]="filterText" (ngModelChangeDebounced)="applyFilter()"
                       [ngModelChangeDebounceTime]="400" cvLocalizedPlaceholder langSection="Common" langKey="Search" />
                <span class="clear-input" [hidden]="filterText.length == 0" (click)="clearSearch()"></span>
            </div>
        </div>
    </div>

    <cv-objective-add-edit *ngIf="objectiveService.showAddEditObjective"></cv-objective-add-edit>
    <cv-objective-metrics-assigned [(filtertext)]="filterText" *ngIf="objectiveService.showLandingMetricTab && !objectiveService.showAddEditObjective"></cv-objective-metrics-assigned>
    <cv-objective-groups-assigned [(filtertext)]="filterText" *ngIf="objectiveService.showLandingGroupsTab && !objectiveService.showAddEditObjective"></cv-objective-groups-assigned>
</div>
